module.exports = __webpack_public_path__ + "static/media/lease3_img1.7820d6cb.jpg";